module.exports = { // this could be any name except the already registered ones
  type: 'perItem', // full, perItem or perItemReverse
  description: 'dataName to className',
  params: {}, // some arbitrary data
  fn: function(item, params) {
    // custom plugin code goes here
    if (item.hasAttr('data-name') && !item.hasAttr('xmlns')) {
      var name = item.attr('data-name')
      // add class attribute using id value
      item.addAttr({
        name: 'class',
        value: name.value,
        prefix: '',
        local: 'class'
      })
    }
    item.removeAttr('data-name')
    item.removeAttr('xmlns')
  }
}